import { apiConstants } from '../../apiConstant'
import { serviceCall, formDataCommonFunction } from '../../serviceCall'

export const callNoteDetails= (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunction(data,apiConstants.VIDEO.CALL_NOTE_DETAILS)
      .then((response) => {
        callback && callback(response)
      
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
    // serviceCall({
    //   url: apiConstants.VIDEO.CALL_NOTE_DETAILS,
    //   method: 'get',
    //   data: data,
    // })
    //   .then((response) => {
    //     callback && callback(response)
    //   })
    //   .catch((error) => {
    //     errorCallBack && errorCallBack(error.response)
    //   })
  }
}
